import { useOverlayContext, useStoreActions } from '~/contexts';
import { useLocaleKeys } from '~/i18n';
import { ServerError } from '~/infra/ErrorResponse';
import { handleRequest } from '~/infra/utils';
const loaderName = 'updateRelationship';
export function useUpdateRelationship() {
    const { api } = useStoreActions();
    const { t: commonTexts } = useLocaleKeys('common');
    const { t: errorTexts } = useLocaleKeys('errors');
    const { startLoader, stopLoader, showErrorToast, showSuccessToast } = useOverlayContext();
    return async function updateRelationship(param) {
        let { id, version, changes, onSuccess } = param;
        startLoader(loaderName);
        const updateResult = await handleRequest(api.relationship.update(id, {
            version,
            changes
        }));
        if (!updateResult.success) {
            showErrorToast(updateResult.error.hasServerError(ServerError.MismatchingRelationshipVersion) ? errorTexts.mismatchingRelationshipVersion() : errorTexts.unexpected(), 'edit-agr-error');
            return stopLoader(loaderName);
        }
        onSuccess && await onSuccess();
        showSuccessToast(commonTexts.toasts.changesSavedSuccessfully(), 'edit-agr-success');
        stopLoader(loaderName);
    };
}
